export default __webpack_public_path__ + "static/media/11.3bcc23fb.png";